import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput';
import { t } from 'utils/getTranslations';
import InfoTooltip from 'components/InfoTooltip';
import { MatterFormState } from './useMatterForm';

/** Other: the experience-record exclusion. */
export const OtherFields = ({ form }: { form: MatterFormState }): JSX.Element => {
    const { control } = form.methods;
    const { xrs } = form;

    return (
        <>
            <CheckboxInput
                control={control}
                name="isExcludedFromXR"
                label="matters.excluded-from-xr"
                tooltip={<InfoTooltip text="matters.excluded-from-xr-tooltip" />}
                validate={(value) => {
                    if (value && xrs?.content.length) {
                        return t('validation.matter-xr-related');
                    }
                }}
            />
        </>
    );
};
